module.exports = __webpack_public_path__ + "static/media/D385GriffinStNW_2018-06-05_46.60e7ff7e.jpg";